import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { ImportUserService } from './import-user.service';

@Component({
  selector: 'app-import-user',
  templateUrl: './import-user.component.html',
  styleUrls: ['./import-user.component.scss']
})
export class ImportUserComponent implements OnInit {
  @ViewChild('validationError') validationErrorModel!: TemplateRef<any>;
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  headers: any = [];
  roleValue: any[] = [];
  isOutlet: boolean = false;
  constructor(public dialog: MatDialog, private toastr: ToastrService, private importUserService: ImportUserService) { }
  ngOnInit(): void {
    const data = history.state.page.name;
    if (data == 'outlet') {
      this.isOutlet = true;
    } else {
      this.isOutlet = false;
    }
  }

  file: File | any = null;
  uploadedFile: File | any = null;

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onFileDrop(event: any) {
    event.preventDefault();
    this.file = event.dataTransfer.files[0];
    if (event.dataTransfer && event.dataTransfer.files.length) {
      this.validateFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    // const files: FileList = event.target.files;
    this.file = event.target.files[0];
    if (input.files && input.files.length) {
      this.validateFile(input.files[0]);
    }
  }

  validateFile(file: File) {
    const validExtensions = ['csv', 'xlsx', 'xls'];
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const fileSize = file.size;

    if (fileExtension && validExtensions.includes(fileExtension)) {
      // if (fileSize <= maxSizeInBytes) {
      this.uploadedFile = file;
      // } else {
      //   this.toastr.error('File size exceeds 10MB!');
      //   this.uploadedFile = null;
      //   this.file = null;
      // }
    } else {
      this.toastr.error('Invalid file type!');
      this.uploadedFile = null;
      this.file = null;
    }
  }

  validationData: any = []
  uploadFileOutlet() {
    this.validationData = [];
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      this.importUserService.bulkUploadOutlet(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }

  uploadFileDealer() {
    this.validationData = [];
    if (this.file) {
      this.isLoading = new BehaviorSubject<boolean>(true);
      const formData: any = new FormData();
      formData.append('leadFile', this.file);
      this.importUserService.bulkUploadDealer(formData).subscribe((res: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        if (res.body.responseCode == 200) {
          this.deleteFile();
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.success(res.body.responseMessage);
        } else {
          const url = res.body.data.download_url;
          const link = document.createElement('a');
          link.href = url;
          link.download = 'FILENAME'; // Optional: specify the filename
          link.click();
          this.toastr.error(res.body.responseMessage);
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    } else {
      this.toastr.error('No file selected or invalid file type!');
    }
  }

  openValidations() {
    this.dialog.open(this.validationErrorModel, {
      width: '600px',
      height: '70vh'
    });
  }

  deleteFile(): void {
    this.uploadedFile = null;
  }
  onClose() {
    this.dialog.closeAll();
  }

  upload() {
    if (this.isOutlet) {
      this.uploadFileOutlet()
    } else {
      this.uploadFileDealer()
    }
  }
}
